module.exports = __webpack_public_path__ + "img/home_lottery_type5.36d491c7.png";